"use client";

import type { ReactNode } from "react";

import { I18nProvider } from "@/components/i18n-provider";
import { MarketingUserProvider } from "@/components/marketing-user-provider";
import { ReactQueryProvider } from "@/components/react-query-provider";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import type { UserSummary } from "@/lib/auth/user-summary";
import type { Locale } from "@/lib/i18n-config";
import type { Dictionary } from "@/types/i18n";

export function MarketingProviders({
  children,
  dictionary,
  locale,
  user,
}: {
  children: ReactNode;
  dictionary: Dictionary;
  locale: Locale;
  user: UserSummary | null;
}) {
  return (
    <MarketingUserProvider user={user}>
      <I18nProvider locale={locale} dictionary={dictionary}>
        <ThemeProvider
          attribute="class"
          defaultTheme="light"
          disableTransitionOnChange
        >
          {/* Marketing pages host React Query consumers too: the hosted
              payment return page polls /status, and the guest checkout
              dialog renders QrisPaymentStep. Without a client here they
              throw on first render. */}
          <ReactQueryProvider>
            {children}
            <Toaster />
          </ReactQueryProvider>
        </ThemeProvider>
      </I18nProvider>
    </MarketingUserProvider>
  );
}
